// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"62":"99744add","596":"d568a1af"}[chunkId] + ".css";
};